import React from 'react';
import {
  DropDownList,
  DropDownListProps,
} from '@progress/kendo-react-dropdowns';

type DynamicDropDownListProps = DropDownListProps & {
  /**
   * Optional width for the input
   */
  width?: number | string;

  /**
   * Optional min width for the popup
   */
  minWidth?: number | string;
};

const DynamicDropDownList: React.FC<DynamicDropDownListProps> = ({
  width = 200,
  minWidth,
  data,
  popupSettings,
  ...props
}) => {
  const popupMinWidth = minWidth ?? width;

  return (
    <DropDownList
      {...props}
      data={data}
      style={{ width }}
      popupSettings={{
        width: 'auto', // auto-grow popup
        style: { minWidth: popupMinWidth }, // enforce min-width
        ...popupSettings,
      }}
    />
  );
};

export default DynamicDropDownList;
